// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"1ff75f2d","214":"b39a97d6","386":"f8e670b5","458":"45881b13","577":"66801e42","652":"34876035","665":"3bf12b26","682":"d5252985","726":"3daeff63","783":"c66ca607","812":"e16e9c63","867":"d2984a3d","904":"0c67cfd9","985":"de897744","997":"f8c56c24"}[chunkId] + ".js";
};